"use client";

import { Dialog, DialogContent } from "@/components/ui/Dialog";
import usePost from "@/hooks/usePost";
import { getNearestGrosByLocation } from "@/services/register";
import { useState } from "react";
import Congratulations from "./Congratulations";
import GetLocation from "./GetLocation";
import SearchingForGrosLoading from "./SearchingForGrosLoading";
import RegisterPhone from "./RegisterPhone";

const RegisterByLocationDialog = ({
  registerId,
  setShowLocationDialog,
  showLocationDialog,
  isByGoogle,
}) => {
  const [nearestGros, setNearestGros] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const { handlePost, isLoading } = usePost(handleGetNearestGros, [], {
    showErrorToast: true,
  });

  async function handleGetNearestGros() {
    const gros = await getNearestGrosByLocation(
      registerId,
      selectedLocation?.latitude,
      selectedLocation?.longitude,
      isByGoogle
    );

    setNearestGros(gros);
  }

  const onDialogOpenChange = open => {
    setShowLocationDialog(open);
    if (!open) {
      setNearestGros(null);
      setSelectedLocation(null);
    }
  };

  return (
    <Dialog
      className="transition-all duration-1000 ease-in-out"
      open={showLocationDialog}
      onOpenChange={onDialogOpenChange}
    >
      <DialogContent
        onInteractOutside={e => e.preventDefault()}
        className="z-[1000] transition-all duration-1000 ease-in-out text-foreground"
        overlayClassName="z-[1000]"
      >
        {nearestGros ? (
          <Congratulations nearestGros={nearestGros} />
        ) : isLoading ? (
          <SearchingForGrosLoading />
        ) : isByGoogle ? (
          <RegisterPhone registerId={registerId} />
        ) : (
          <GetLocation
            handleSubmit={handlePost}
            setSelectedLocation={setSelectedLocation}
            selectedLocation={selectedLocation}
            isLoading={isLoading}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default RegisterByLocationDialog;
